<template>
    <div class="tab-pane active">
        <div class="row mt-2 mb-3">
            <div class="col-md-7">
                <input class="form-control custom-green-input-bg" :placeholder="`${$t('Search')}...`" type="text" v-model="term"/>
            </div>
            <div class="col-md-5">
                <app-button v-if="term" native-type="button" type="warning" @click="cancelFilter" class="mt-1" small>
                    {{ $t('Cancel') }}
                </app-button>
                <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" @click="$modal.show('create_make')" class="mt-1" small>
                    {{ $t('Create make') }}
                </app-button>
                <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" @click="$modal.show('create_model')" class="mt-1" small>
                    {{ $t('Create model') }}
                </app-button>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('Name') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(make, makeIndex) in filteredMakes" :key="makeIndex">
                        <td>{{ makeIndex + 1 }}</td>
                        <td>
                            <div class="d-flex justify-content-between">
                                <p class="font-weight-bold">{{ make.name }}</p>
                                <app-button native-type="button"
                                            type="success"
                                            data-toggle="collapse"
                                            :data-target="`#model_${make.id}`"
                                            aria-expanded="false"
                                            :aria-controls="`model_${make.id}`"
                                            small>
                                    {{ $t('Models') }}
                                </app-button>
                            </div>
                            <div v-for="(model, i) in make.models" :key="i" class="collapse" :id="`model_${make.id}`">
                                <div class="card mb-1">
                                    <div class="card-body p-1">
                                        <div class="d-flex">
                                            <div class="w-25">
                                                <h6 class="mb-0 mt-2">{{ model.name }}</h6>
                                            </div>
                                            <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_model', {model, makeIndex})" class="ml-2" small>
                                                {{ $t('Edit') }}
                                            </app-button>
                                            <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroyModel(model.id)" small>
                                                {{ $t('Delete') }}
                                            </app-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="p-0">
                            <div class="text-right">
                                <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_make', {make})" class="ml-2" small>
                                    {{ $t('Edit') }}
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <create-make-modal @setMake="setMake"/>
        <update-make-modal @setMake="setMake"/>
        <create-model-modal @setModel="setModel"/>
        <update-model-modal @setModel="setModel"/>
    </div>
</template>

<script>
import MakesModelsService from '@services/makesModels.service';
import CreateMakeModal from './modals/CreateMake';
import UpdateMakeModal from './modals/UpdateMake';
import CreateModelModal from './modals/CreateModel';
import UpdateModelModal from './modals/UpdateModel';
import {mapGetters} from 'vuex';
import Vue from 'vue';
import PromocodeService from '@services/promocode.service';

export default {
    data() {
        return {
            makes: [],
            term: '',
        };
    },
    computed: {
        ...mapGetters(['locale']),
        filteredMakes() {
            if (this.makes.length) {
                return this.makes.filter(make => {
                    const term = this.term.toLowerCase();
                    return make.name.toLowerCase().match(term);
                });
            }
            return false;
        },
    },
    methods: {
        cancelFilter() {
            this.term = '';
        },
        getMakes() {
            MakesModelsService.makesModels().then(res => this.makes = res);
        },
        setMake(make) {
            const index = this.makes.findIndex(p => p.id === make.id);
            if(index !== -1) {
                Vue.set(this.makes, index, make);
            } else {
                this.makes.push(make);
            }
        },
        setModel(data) {
            if(data.makeIndex) {
                const index = this.makes[data.makeIndex].models.findIndex(p => p.id === data.model.id);
                if(index !== -1) {
                    Vue.set(this.makes[data.makeIndex].models, index, data.model);
                } else {
                    console.log('no make');
                }
            } else {
                const index = this.makes.findIndex(p => p.id === data.model.make_id);
                if(index !== -1) {
                    this.makes[index].models.push(data.model);
                }
            }
        },
        destroyModel(modelId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            MakesModelsService.destroyModel(modelId).then(res => {
                this.makes.forEach(make => {
                    const index = make.models.findIndex(m => m.id === modelId);
                    make.models.splice(index, 1);
                });
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateMakeModal,
        UpdateMakeModal,
        CreateModelModal,
        UpdateModelModal
    },
    created() {
        this.getMakes();
    },
    metaInfo() {
        return {
            title: this.$t('Makes and models')
        };
    }
};
</script>
